// @flow weak

export { default as AsideLeft }   from './asideLeft/AsideLeft';
export { default as AsideRight }  from './asideRight/AsideRight';



// WEBPACK FOOTER //
// ./src/app/components/aside/index.js